<template>
    <div class="filters">
        <div class="filters__sort-by">
            <ui-field name="Sortuj wg:">
                <select @change="onChangeSort" :value="sortBy" class="select">
                    <option value="name">Nazwa</option>
                    <option value="lastPrice">Cena</option>
                    <option value="region">Region</option>
                </select>
            </ui-field>
        </div>
    </div>
</template>

<script>
import uiField from '@/components/ui/form/Field.vue';

export default {
  data() {
    return {
      selected: 'name',
    };
  },

  props: {
    sortBy: String,
  },

  methods: {
    onChangeSort(event) {
      this.$emit('changeSorting', {
        by: event.target.value,
      });
    },
  },

  components: {
    uiField,
  },
};
</script>

<style lang="scss">
    .filters {
        &__sort-by {
            width: 20%;
        }
    }
    .select {
        border: 1px solid #b6b6b6;
        background: transparent;
        width: 100%;
        display: block;
        height: 32px;
        outline: none;
        font-size: 0.9rem;
    }
</style>
